import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { _ } from 'underscore';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommercialService {

  deviceWidth;
  currentId;
  private messageSource = new BehaviorSubject({});
  currentMessage = this.messageSource.asObservable();
  private unselectSource = new BehaviorSubject({});
  currentunSelect = this.unselectSource.asObservable();
  cominputQuestions;
  actualQuestions;
  userResponse = {
    'userResponses' : []
  };
  address;
  selectedType;
  service;
  filteredQues;
  addAddress = false;
  serialNumber = null;
  modifyAddress =  false;
  url = environment.api_url;

  // For attachments
  attachments = [];

  constructor(private http: HttpClient) { }

  public setQuestions(questions) {
    this.cominputQuestions = questions;
    this.actualQuestions = this.cominputQuestions;
  }

  public getQues() {
    return this.cominputQuestions;
  }

  public setServiceType(selectedValue) {
    this.selectedType = selectedValue;
  }

  public messageService(message: {}) {
    if (message['currentId']) {
      this.currentId = message['currentId'];
    }
    if (message['service']) {
      this.service =  message['service'];
      if (message['service'] === 'Switching Providers') {
        const filtered = _.filter(this.actualQuestions, function(item) {
          return item.service === 'Switching Providers' || item.service === 'Both';
        });
        this.cominputQuestions = filtered;
      } else if (message['service'] === 'New Service') {
        const filtered = _.filter(this.actualQuestions, function(item) {
          return item.service === 'New Service' || item.service === 'Both';
        });
        this.cominputQuestions = filtered;
      }
    }
    this.messageSource.next(message);
  }

  public updateResponses(response) {
    const foundElem = _.findWhere(this.userResponse.userResponses, {'com_question_id': response.com_question_id});
    if ( foundElem === undefined) {
      this.userResponse.userResponses.push(response);
    } else {
      this.userResponse.userResponses = _.map(this.userResponse.userResponses, function(item, index) {
        if (item && response && item.com_question_id === response.com_question_id) {
          // // console.log.log('date updated:' + response.fieldName);
          item = response;
        }
        return item;
      });
    }
    sessionStorage.setItem('commercialResponses', JSON.stringify(this.userResponse));
  }

  filter(responsess) {
    if (!_.isEmpty(responsess)) {
      this.userResponse.userResponses = responsess;
      const findService = _.findWhere(responsess, {'fieldName': 'service'});
      if (!_.isEmpty(findService)) {
        // this.service = findService.fieldValue[0].value;
        // this.setServiceType(this.service);
        if (this.selectedType === 'Switching Providers') {
          const filtered = _.filter(this.actualQuestions, function(item) {
            return item.service === 'Switching Providers' || item.service === 'Both';
          });
          this.cominputQuestions = filtered;
        } else if (this.selectedType === 'New Service') {
          const filtered = _.filter(this.actualQuestions, function(item) {
            return item.service === 'New Service' || item.service === 'Both';
          });
          this.cominputQuestions = filtered;
        }
      }
      this.filteredQues = this.cominputQuestions;
    }
  }

  public unSelectService(message: {}) {
    this.unselectSource.next(message);
  }

  public getUtilies(zipcode: any,address: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };
    const zipJson = JSON.stringify({
      'Zip': zipcode,
      'Address': address
    });
    return this.http.post(this.url + '/getUtilitiesForCommercial', zipJson, httpOptions);
  }
}
